import type { TypedPlaybackUrlData } from '@dicetechnology/dice-doris';
import { EncryptionModes } from '@dicetechnology/dice-doris';

export const preferDashStreams = (a: TypedPlaybackUrlData, b: TypedPlaybackUrlData) => {
    const typeOrder = { dash: 1, hls: 2, hlsWidevine: 2 };
    if (typeOrder[a.type] < typeOrder[b.type]) {
        return -1;
    }
    if (typeOrder[a.type] > typeOrder[b.type]) {
        return 1;
    }

    const encryptionModeOrder = {
        [EncryptionModes.CTR]: 1,
        [EncryptionModes.CBC]: 2,
        CLEAR: 3
    };
    if (encryptionModeOrder[a.drm?.encryptionMode ?? 'CLEAR'] < encryptionModeOrder[b.drm?.encryptionMode ?? 'CLEAR']) {
        return -1;
    }
    if (encryptionModeOrder[a.drm?.encryptionMode ?? 'CLEAR'] > encryptionModeOrder[b.drm?.encryptionMode ?? 'CLEAR']) {
        return 1;
    }

    return 0;
};
